/* tslint:disable */
type DigitaloceanVolumesFilesystemType =
  'VolumesFilesystemTypeRaw' |
  'VolumesFilesystemTypeExt4' |
  'VolumesFilesystemTypeXfs';
module DigitaloceanVolumesFilesystemType {
  export const VOLUMES_FILESYSTEM_TYPE_RAW: DigitaloceanVolumesFilesystemType = 'VolumesFilesystemTypeRaw';
  export const VOLUMES_FILESYSTEM_TYPE_EXT_4: DigitaloceanVolumesFilesystemType = 'VolumesFilesystemTypeExt4';
  export const VOLUMES_FILESYSTEM_TYPE_XFS: DigitaloceanVolumesFilesystemType = 'VolumesFilesystemTypeXfs';
  export function values(): DigitaloceanVolumesFilesystemType[] {
    return [
      VOLUMES_FILESYSTEM_TYPE_RAW,
      VOLUMES_FILESYSTEM_TYPE_EXT_4,
      VOLUMES_FILESYSTEM_TYPE_XFS
    ];
  }
}

export { DigitaloceanVolumesFilesystemType }